import Gobalstore from "../index";
import { auth } from "../../../firebaseConfig";

export const actions = {
  loginAndSaveToken: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    var that = this;

    return this.axios({
      method: "POST",
      url: "/business/login",
      data: payload.user,
      headers: payload.headers
    })
      .then((response) => {
        localStore.commit("setToken", response.data["access_Token"]);
        localStorage.setItem("access_Token", response.data["access_Token"]);
        localStorage.setItem("refresh_token", response.data["refresh_token"]);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        Gobalstore.commit("LoadingOverlay", false);
        return response;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
  },

  register: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    const body = localStore.state.registration;
    var that = this;
    return this.axios({
      method: "POST",
      url: "/business/user",
      data: body,
      headers: payload.headers
    })
      .then((res) => {
        Gobalstore.commit("LoadingOverlay", false);
        return res;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
  },

  requestOTP: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    var that = this;
    return this.axios({
      method: "POST",
      url: "/business/requestOTP",
      data: payload.data,
      headers: payload.headers
    })
      .then((res) => {
        Gobalstore.commit("LoadingOverlay", false);
        return res;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
  },

  resetPassword: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    var that = this;
    return this.axios({
      method: "POST",
      url: "/business/resetPassword",
      data: payload.data,
      headers: payload.headers
    })
      .then((res) => {
        Gobalstore.commit("LoadingOverlay", false);
        return res;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
  },

  changePassword: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    var that = this;
    return this.axios({
      method: "PATCH",
      url: "/business/guarded/user/password",
      data: payload.data,
      headers: payload.headers
    })
      .then((res) => {
        Gobalstore.commit("LoadingOverlay", false);
        return res;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
  },

  resendOTP: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    const body = localStore.state.registration;
    var that = this;
    return this.axios({
      method: "POST",
      url: "/business/resendOTP",
      data: body,
      headers: payload.headers
    })
      .then((res) => {
        Gobalstore.commit("LoadingOverlay", false);
        return res;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
  },

  logout: function (localStore) {
    localStore.commit("setToken", "");
    localStorage.removeItem("access_Token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");

    var that = this;
    that.router.push({ path: "/login" });

  },

  otpConfirm: async function (localStore, payload) {
    Gobalstore.commit("LoadingOverlay", true);
    const body = localStore.state.registration;
    var that = this;
    return this.axios({
      method: "PATCH",
      url: "/business/user-verify-otp",
      data: body,
      headers: payload.headers
    })
      .then((response) => {
        Gobalstore.commit("LoadingOverlay", false);
        return response;
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        return err;
      });
  },

  getUser: function (localStore) {
    var that = this;
    this.axios({
      method: "GET",
      url: "/business/guarded/user",
    })
      .then((res) => {
        Gobalstore.commit("LoadingOverlay", false);
        localStorage.setItem("user", JSON.stringify(res.data));
        that.router.push({ path: "/main" });
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
        console.log(err);
      });
  },

  getUserMain: function (localStore) {
    this.axios({
      method: "GET",
      url: "/business/guarded/user",
    })
      .then((res) => {
        Gobalstore.commit("LoadingOverlay", false);
        localStorage.setItem("user", JSON.stringify(res.data));
      })
      .catch((err) => {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },
};
